import {
  CubeTimeDimensionGranularity,
  CubeRequestConfig,
} from '../../../../common';
import { SharedOrgMetricsRequestDto } from '../../common/shared-org-metrics-request.dto';

export interface GetUserWorkingSessionsRequestDto {
  params: {
    startDate: string;
    endDate: string;
    timezone: string;
    userIds?: string[];
  };
  config: CubeRequestConfig;
}
